import {stateData, reduxState} from '../../values';

export const getPartners = (data) =>{
    return(dispatch) =>{
        dispatch({
            type:       reduxState.get_partners,
            payload:    data.Data,
            status:     stateData.state2,
            records:    data.Records
        })
    }
}

export const updatePartners = (data) =>{
    return(dispatch) =>{
        dispatch({
            type:       reduxState.update_partners,
            payload:    data,
        })
    }
}